function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M254.7,225.6L150,76.7L45.3,225.6"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M184.4,23.9l0.8-1.2c0.1-0.3,0.2-0.6,0.2-0.9c0-4.5-14.2-9.3-35.4-9.3s-35.4,4.8-35.4,9.3c0,0.3,0.1,0.7,0.2,1 l0.7,1"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M182.2,27.1c-6.6,3.5-19.6,5.4-32.2,5.4c-12.6,0-25.6-2-32.2-5.4L150,75.2L182.2,27.1z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M226.3,217.1c-20.4-5.7-47.5-8.8-76.3-8.8s-55.9,3.1-76.3,8.8c-19.8,5.5-31.2,13-31.2,20.6 c0,3.8,6.5,23.6,12.9,25.7c1.6,0.5,3.1-0.2,4.6-2.3c3.7-5.2,7.6-7.8,11.8-7.8c0.2,0,0.5,0,0.7,0c10.2,0.7,18.5,17.1,21.7,23.2 c6.3,12.3,14.4,18.9,22.3,18.1c5.2-0.5,14.9-5,21.5-28.7c4.1-14.8,20.4-16.7,34.1-16.7c17.2,0,39.2-0.2,56.3-1.9 c24-2.3,29.1-6.5,29.1-9.7C257.5,230.1,246.1,222.6,226.3,217.1z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    version: 1.1,
    id: "Layer_1",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 300",
    style: {
      "enableBackground": "new 0 0 300 300"
    },
    xmlSpace: "preserve"
  }, props), _ref, _ref2, _ref3, _ref4);
};

export default __webpack_public_path__ + "static/media/hourglass.87eb6179.svg";
export { SvgComponent as ReactComponent };